export default {
  nodes: [
    {
      match: {
        object: 'text',
      },
      min: 1,
      max: 1,
    },
  ],
};
